import Cookies from "universal-cookie";

const cookies = new Cookies();
const API_URL = process.env.REACT_APP_API_URL;

/**
 * Strip old storage prefixes to get a clean, relative S3 key.
 */
const cleanPath = (path) => {
    if (!path) return "";

    return path
        // strip s3:// bucket prefix (e.g. s3://atlantic-object-bucket/)
        .replace(/^s3:\/\/[^/]+\//, "")
        // strip old absolute server prefix
        .replace("/var/www/html/atlantic-brokers/storage/app/public/", "")
        // strip bare "public/" prefix (some paths use this)
        .replace(/^public\//, "")
        // remove any leading slashes
        .replace(/^\/+/, "");
};

/**
 * Synchronous: build an API download URL for a file.
 *
 * Use this for <a href>, <embed src>, window.open — anywhere
 * a URL is needed immediately (not awaitable).
 *
 * Routes through the backend download endpoint which streams
 * the file from S3 with auth via query param token.
 */
export const getFileUrl = (path) => {
    if (!path) return "#";
    const cleaned = cleanPath(path);
    const safePath = cleaned
        .split("/")
        .map(encodeURIComponent)
        .join("/");
    const token = cookies.get("token_user");
    return `${API_URL}/user/shipments/download/${safePath}?token=${token}`;
};

/**
 * Async: fetch a temporary pre-signed S3 URL from the backend.
 *
 * Use this for fetch()-based downloads (e.g. zip builder) where
 * you can await a URL before fetching the file content.
 *
 * The pre-signed URL is valid for 30 minutes.
 */
export const getSignedUrl = async (path) => {
    if (!path) return null;
    const cleaned = cleanPath(path);
    const safePath = cleaned
        .split("/")
        .map(encodeURIComponent)
        .join("/");

    const token = cookies.get("token_user");

    try {
        const res = await fetch(
            `${API_URL}/user/shipments/signed-url/${safePath}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            }
        );

        if (!res.ok) return null;

        const data = await res.json();
        return data.url;
    } catch {
        return null;
    }
};

/**
 * Extract just the filename from a path.
 */
export const getFileName = (path) => {
    if (!path) return "";
    return path.split("/").pop();
};
